export const ICON_SEARCH_LABEL = 'Search icons';
